var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatYouGet6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_431_10783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#A0616A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9998 77.333H50.6665V90.6663L42.3332 85.6663L33.9998 90.6663V77.333ZM80.6665 17.333H53.9998V90.6663L62.3332 85.6663L70.6665 90.6663V83.9997H80.6665C82.4346 83.9997 84.1303 83.2973 85.3805 82.0471C86.6308 80.7968 87.3332 79.1011 87.3332 77.333V23.9997C87.3332 22.2316 86.6308 20.5359 85.3805 19.2856C84.1303 18.0354 82.4346 17.333 80.6665 17.333ZM60.6665 30.6663H67.3332V37.333H60.6665V30.6663ZM60.6665 47.333H67.3332V53.9997H60.6665V47.333ZM60.6665 63.9997H67.3332V70.6663H60.6665V63.9997ZM27.3332 17.333C25.5667 17.3383 23.8741 18.0424 22.625 19.2915C21.3759 20.5406 20.6718 22.2332 20.6665 23.9997V77.333C20.6718 79.0995 21.3759 80.7921 22.625 82.0412C23.8741 83.2903 25.5667 83.9944 27.3332 83.9997V23.9997H50.6665V17.333H27.3332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.667H40.6667V37.3337H34V30.667ZM34 47.3337H40.6667V54.0003H34V47.3337ZM34 64.0003H40.6667V70.667H34V64.0003Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_10783",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_10783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_10783",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYouGet6);
export default __webpack_public_path__ + "static/media/WhatYouGet6.88f1309d1468e8d482f6becdff8bd73a.svg";
export { ForwardRef as ReactComponent };